import Auth from '@/auth'

class ApiHelper {
  static async fetch(url, fetchOptions) {
    const options = Object.assign(
        {},
        {
          method: 'GET',
          mode: 'cors',
          redirect: 'follow',
          credentials: 'same-origin', // 'include',
          cache: 'no-cache',
          headers: new Headers({
            'Content-Type': 'application/json; charset=utf-8'
          })
        },
        fetchOptions || {}
      ),
      token = Auth.getToken()

    if (token) {
      options.headers.append('Authorization', `Token ${token}`)
    }

    function checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response
      }
      const error = new Error(response.statusText)
      error.response = response
      throw error
    }

    const request = new Request(url, options)

    try {
      const response = await fetch(request)
      checkStatus(response)
      const data = await response.json()
      return {
        ...data,
        _origin: url
      }
    } catch (err) {
      console.warn(`ApiHelper.fetch: ${url} `, err.message || err)
      if (!err.response) {
        return err
      }
      if (err.response.headers.get('Content-Type').startsWith('application/json')) {
        const response = await err.response.json()
        err.errors = response.errors
        err.parsedResponse = response
      }

      throw err
    }
  }
}

export default ApiHelper
